import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import {
  mediaQueries,
  size,
  typography,
  colors,
  TertiaryLink,
} from '@everlywell/leaves';

export const Resource = styled.div`
  margin-bottom: ${size.xl2}px;
`;

export const Image = styled(GatsbyImage)`
  width: 100%;
`;

export const Type = styled.p`
  ${typography.overlineText}
  color: ${colors.teal4};
  font-weight: ${typography.weight.bold};
  margin-top: ${size.xl2}px;
  margin-bottom: 0;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: 0;
  }

  ${mediaQueries.forDesktopUp} {
    margin-bottom: ${size.lg}px;
    margin-top: ${size.xl2}px;
  }
`;

export const Title = styled.h2`
  ${typography.h4Text};
  margin-bottom: ${size.sm}px;
  margin-top: ${size.sm}px;

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.subtitle};
    color: ${colors.teal4};
  }

  ${mediaQueries.forDesktopUp} {
    ${typography.h4Text};
    margin-top: 0;
  }
`;

export const Summary = styled.div`
  ${typography.bodyTextSmall};
  font-weight: ${typography.weight.light};

  ${mediaQueries.forDesktopUp} {
    ${typography.bodyText};
    line-height: 29px;
    letter-spacing: 0.5px;
  }
`;

export const CTA = styled(TertiaryLink)`
  margin-top: ${size.sm}px;
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;
